<template>
    <div class="transition-slide" :style="styles">
        <component :is="component" :name="name" @enter="setHidden(true)" @after-leave="setHidden(false)">
            <slot></slot>
        </component>
    </div>
</template>

<script lang="ts" setup>
import { TransitionGroup, Transition, computed, markRaw, reactive } from "vue";
import { TransitionSlideDirection } from "./transition-slide-direction";

const props = withDefaults(
    defineProps<{
        direction: TransitionSlideDirection;
        isGroup?: boolean;
    }>(),
    {
        direction: "rtl",
    }
);

const component = computed(() => (props.isGroup ? markRaw(TransitionGroup) : markRaw(Transition)));

const styles = reactive({
    overflow: "visible",
});

const setHidden = (value: boolean) => {
    styles.overflow = value ? "hidden" : "visible";
};

const name = computed(() => "slide--" + props.direction);
</script>
